import { DEFAULT_THEMES } from 'configs/constant';

export default {
    defaultIsDarkMode: false,
    defaultIsRTL: false,
    zIndex: DEFAULT_THEMES.Z_INDEX,
    appBar: DEFAULT_THEMES.APP_BAR,
    toolBar: DEFAULT_THEMES.TOOL_BAR,
    // MASK_VIDEO: MaskVideo,
    EXIT_ANIMATION_DURATION: 1,
    BTN_TYPE: {
        PRIMARY: 'primary',
        SECONDARY: 'secondary',
        DEFAULT: 'default'
    },
    // customize
    font: {
        fontSize: {
            miniTitle: 'calc( var(--app-height) * 0.0173 + 2.5px - var(--app-height) * 0.0005 )',
            smallTitle: 'calc( var(--app-height) * 0.0202 + 2.5px - var(--app-height) * 0.0005 )',
            normalTitle: 'calc( var(--app-height) * 0.0216 + 2.5px - var(--app-height) * 0.0005 )',
            bigTitle: 'calc( var(--app-height) * 0.0230 + 2.5px - var(--app-height) * 0.0005 )',
            extraBigTitle: 'calc( var(--app-height) * 0.0346 + 2.5px - var(--app-height) * 0.0005 )',
            miniContent: 'calc( var(--app-height) * 0.0101 + 2.5px - var(--app-height) * 0.0005 )',
            smallContent: 'calc( var(--app-height) * 0.0129 + 2.5px - var(--app-height) * 0.0005 )',
            normalContent: 'calc( var(--app-height) * 0.0144 + 2.5px - var(--app-height) * 0.0005 )',
            bigContent: 'calc( var(--app-height) * 0.0151 + 2.5px - var(--app-height) * 0.0005 )'
        },
        fontWeight: {
            thin: 100,
            extraLight: 200,
            light: 300,
            normal: 400,
            medium: 500,
            semiBold: 600,
            bold: 700,
            extraBold: 800
        }
    }
};
